export default {
  data () {
    return {
      fields: [
        {
          prop: 'id',
          label: 'ID',
          width: 80,
        },
        {
          prop: 'desc',
          label: '回款描述',
          minWidth: 120,
        },
        {
          prop: 'customer_number',
          label: '客户编号',
          minWidth: 160,
          formatter: row => `${row.customer_name}/${row.customer_number}`
        },
        {
          prop: 'receipt_info_company_name',
          label: '公司名称',
          minWidth: 120,
        },
        {
          prop: 'our_company_id',
          label: '收款公司',
          minWidth: 120,
          formatter: row => this.paymentCompanies[row.our_company_id]
        },
        {
          prop: 'type',
          label: '回款类型',
          minWidth: 90,
          formatter: row => this.collectionTypeText[row.type]
        },
        {
          prop: 'collection_amount',
          label: '回款金额',
          minWidth: 120,
        },
        {
          prop: 'received_date',
          label: '回款日期',
          minWidth: 120,
          formatter: row => this.formatOnlyDate(row.received_date)
        },
        {
          prop: 'receipt_related_status',
          label: '核销状态',
          minWidth: 120,
          formatter: row => this.receiptRelatedStatus[row.receipt_related_status]
        },
        {
          prop: 'remain_amount_total',
          label: '待核销金额',
          minWidth: 120,
        },
        {
          prop: 'related_amount_total',
          label: '已核销金额',
          minWidth: 120,
        },
        {
          prop: 'creator_name',
          label: '发起人',
          minWidth: 120,
        },
        {
          prop: 'created_at',
          label: '创建时间',
          minWidth: 120,
        },
      ],
      exportHeader: [
        {
          key: 'id',
          text: '回款ID',
        },
        {
          key: 'desc',
          text: '回款描述',
        },
        {
          key: 'customer_number',
          text: '客户编号',
        },
        {key: 'receipt_info_id', text: '开票抬头ID'},
        {
          key: 'receipt_info_company_name',
          text: '公司名称',
        },
        {
          key: 'received_company',
          text: '回款公司',
        },
        {
          key: 'received_bank_info',
          text: '收款账户/银行账号',
        },
        {key: 'type_txt', text: '回款类型'},
        {
          key: 'collection_amount',
          text: '回款金额',
        },
        {
          key: 'received_date',
          text: '回款日期',
        },
        {
          key: 'receipt_related_status',
          text: '核销状态',
        },
        {key: 'related_amount_total', text: '已核销金额'},
        {
          key: 'remain_amount_total',
          text: '待核销金额',
        },
        {
          key: 'creator_name',
          text: '发起人',
        },
        {
          key: 'created_at',
          text: '创建时间',
        },
      ],
      exportSummaryHeader: [
        {
          key: 'received_total',
          text: '回款ID',
        },
        {
          key: 'cnt',
          text: '回款笔数',
        },
        {
          key: 'remain_total',
          text: '已核销金额',
        },
        {
          key: 'related_total',
          text: '待核销金额',
        },
      ],
      exportRelatedHeader: [
        {key: 'id', text: '回款ID'},
        {key: 'desc', text: '回款描述'},
        {key: 'customer_number', text: '客户编号'},
        {key: 'receipt_info_id', text: '开票抬头ID'},
        {key: 'receipt_info_company_name', text: '公司名称'},
        {key: 'received_company', text: '回款公司'},
        {key: 'received_bank_info', text: '收款账户/银行账号'},
        {key: 'type_txt', text: '回款类型'},
        {key: 'collection_amount', text: '回款金额'},
        {key: 'received_date', text: '回款日期'},
        {key: 'receipt_related_status', text: '核销状态'},
        {key: 'assoc_amount', text: '已核销金额'},
        {key: 'receipt_apply_id', text: '开票ID'},
        {key: 'creator_name', text: '发起人'},
        {key: 'created_at', text: '创建时间'},
      ],
    }
  },
  computed: {
    ...Vuex.mapState({
      receiptRelatedStatus: state => state.receivedPayment.receiptRelatedStatus,
      collectionTypeText: state => state.receivedPayment.collectionTypeText,
    }),
  },
  methods: {
    formatOnlyDate: filter.formatOnlyDate,
  },
}



// WEBPACK FOOTER //
// ./src/views/received-payment/received-payment.mixins.js